const path = require('path');

module.exports = {
    id: 'tv2no',
    name: 'tv2no',
    salt: '',
    defaultSCSSPath: path.resolve(__dirname, `../../widgets/themes/tv2no/tv2no.default.scss`),
    themesDir: path.resolve(__dirname, `../../widgets/themes/tv2no/`)
};



/** WEBPACK FOOTER **
 ** ../src/config/clients/tv2no.spec.js
 **/